module.exports = "/images/dedicated-support.png?f08645586c5c5d635ebe40baf7e918f5";